import React, { useState, useEffect } from "react";
import { Space, Col, Row } from "antd";
import { useMediaQuery } from "react-responsive";
import Request from "../../helpers/Request";
import * as yup from "yup"
import { Form, Input, Select, Field, Checkbox } from "formik-antd"
import { Formik, useFormikContext } from "formik"
import StarRating from "./components/StarRating";
import { Modal } from "antd";

const ReviewForm = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  const [rating, setRating] = useState(0);
  const [ratingError, setRatingError] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [reviewValues, setReviewValues] = useState({
    review: {
      email: "",
      name: "",
      rating: "",
      comment: "",
    },
  })

  const placeholder = (name, required = false) => (
    <div className="palceholder">
      {name}
      {required && <span style={{ color: "orange" }}>{"*"}</span>}
    </div>
  )

  const reviewSchema = yup.object().shape({
    review: yup.object().shape({
      email: yup
        .string()
        .max(50, "max 50 simbolių")
        .matches(/^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])$/, "Neteisingas el. pašto adresas")
        .required("Privaloma"),
      name: yup
        .string()
        .matches(/^[A-zÀ-ÿ0-9ąčęėįšųūžĄĘĖĮŲŪČŠŽ\!@#$%^&*()_ +-={}"'|?>]+$/, "Yra neleistinų simbolių")
        .max(50, "Daugiausiai 50 simbolių")
        .required("Privaloma"),
      comment: yup
        .string()
    }),
  })

  const UpdateStateValues = () => {
    const { values } = useFormikContext()
    useEffect(() => {
      // setPersonalValues(values)
    }, [values])
    return null
  }

  return (
    <>
      <div className="review-form">
        <h1 className="review-form-title">
          Atsiliepimai
        </h1>
        <p>
          Norime teikti pačias kokybiškiausias siuntų siuntimo paslaugas, todėl mums svarbi tavo nuomonė!
          <br />
          Įvertink mūsų paslaugas:
        </p>
        <div className="review-form-wrapper">
          <Formik
            enableReinitialize={true}
            onSubmit={(
              data,
              { setSubmitting, setTouched, setErrors, setFieldValue, resetForm }
            ) => {
              const finalData = {
                review: {
                  email: data.review.email,
                  name: data.review.name,
                  rating: data.review.rating,
                  comment: data.review.comment,
                },
              }
              if (parseInt(data.review.rating) === 0) {
                console.log("rating error")
                setRatingError(true);
                setSubmitting(false);
                return;
              }
              setRatingError(false);
              Request("/create_review", "POST", {
                body: finalData,
              })
                .then((response) => {
                  console.log(response)
                  if (response.status == 'ok') {
                    setSubmitting(false)
                    setIsModalVisible(true);
                    resetForm();
                    setRating(0);
                  }
                })
                .catch(({ errors }) => {
                  setSubmitting(false)
                  setErrors({
                    review: errors,
                  })
                })
            }}
            validationSchema={reviewSchema}
            initialValues={reviewValues}
          >
            {({
              isSubmitting,
              isValid,
              setFieldValue,
              errors,
              values,
              touched,
              submitForm,
              isInitialValid,
              validateForm,
              setSubmitting,
              setErrors,
            }) => (
              <Form
                layout="vertical"
                autoComplete="off"
                onKeyDown={(e) => {
                  if ((e.charCode || e.keyCode) === 13) {
                    e.preventDefault()
                  }
                }}
              >
                <UpdateStateValues />
                <div style={{
                  paddingLeft: isMobileScreen ? 0 : 100,
                  paddingRight: isMobileScreen ? 0 : 100,
                }}>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item name="review[name]" required>
                        <Input name="review[name]" size="large" />
                        {!values.review.name && placeholder("Vardas/įmonės pavadinimas", true)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Form.Item name="review[email]" required>
                        <Input name="review[email]" size="large" />
                        {!values.review.email && placeholder("El. paštas", true)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <StarRating rating={rating} setRating={setRating} setFieldValue={setFieldValue} ratingError={ratingError} setRatingError={setRatingError} />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{
                      marginTop: isMobileScreen ? 15 : 0,
                    }}>
                      <Form.Item name="review[comment]" required>
                        <Input.TextArea name="review[comment]" size="large" rows={4} />
                        {!values.review.comment && placeholder("Komentaras", false)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} style={{
                      textAlign: "center",
                    }}>
                      <button
                        type="submit"
                        className="btn btn-primary-alsendo btn-circle"
                        disabled={isSubmitting}
                        style={{
                          width: isMobileScreen ? "100%" : "auto"
                        }}
                      >
                        {"Palikti atsiliepimą"}
                      </button>
                    </Col>
                  </Row>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      {isModalVisible && (
        <Modal
          title="Ačiū!"
          visible={isModalVisible}
          onOk={() => setIsModalVisible(false)}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
        >
          <p>
            Jūsų atsiliepimą gavome.
          </p>
          <button
            type="submit"
            className="btn btn-primary-alsendo btn-circle"
            style={{
              width: isMobileScreen ? "100%" : "auto",
              paddingLeft: 40,
              paddingRight: 40,
            }}
            onClick={() => setIsModalVisible(false)}
          >
            {"Uždaryti"}
          </button>
        </Modal>
      )}
    </>
  );
};

export default ReviewForm;
